// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Video_wrapper__rofnj","video":"Video_video__1kg4-","text":"Video_text__2o-5W"};